// extracted by mini-css-extract-plugin
export default {"wrapper":"CalendarCategoryFilterBlock_wrapper__E8UXl"};